<template>
  <div class="historique">
    <div class="title-container">
      <img
        class="ri-chat-history-fill"
        alt="Ri chat history fill"
        src="/img/ri-chat-history-fill.svg"
      />

      <div class="title">Historique</div>
    </div>
    <div class="text-container">
      <div class="left-text">
        <p >
          En 1993, à la demande et pour le compte d&#39;importateurs européens, quelques opérateurs économiques ont pratiqué le mode de production en agriculture biologique à Madagascar.
        </p>
        <br>
        <p >
          En 1995, un organisme français agréé par l&#39;Union Européennes&#39;est installé à Madagascar pour procéder aux inspections préalablesen vue d&#39;obtenir les certificats de conformité, documents obligatoires pour l&#39;introduction des produits sur le marché international de l&#39;agriculture biologique. Des organismes d&#39;appui intervenant alors à Madagascar ont apporté leur contribution pour que les premiers opérateurs bio de Madagascar puissent obtenir la certification de leurs produits et accéder aux marchés extérieurs.
        </p>
      </div>
      <div class="right-container">
        <div class="img-wrapper">
          <div class="image-container">
            <img
              class="img"
              alt="Depuis l agriculture"
              src="/img/depuis-l-agriculture-biologique-a-pris-un-essor-tangible-le.png"
            />
          </div>

          <div class="image-container">
            <img
              class="img"
              alt="Depuis l agriculture"
              src="/img/depuis-l-agriculture-biologique-a-pris-un-essor-tangible-le-1.svg"
            />
          </div>
        </div>
        <p>
          Depuis, l&#39;agriculture biologique a pris un essor tangible : le nombre d&#39;opérateurs certifiés bio à Madagascar est passé de sept en 1996 à une centaine aujourd&#39;hui. Madagascar ne disposant pas de règlementation nationale, les productions biologiques malgaches sont encore essentiellement destinées à l&#39;exportation et doivent se conformer aux exigences des pays destinataires.
        </p>
      </div>

     
    </div>

    

    
  </div>
</template>

<script>
export default {
  name: "Historique",
};
</script>

<style>
.historique {
  /* background-color: #e6e3b5; */
  /* border-radius: 48px; */
  width: 48vw;
  /* width: 52vw; */
  background-color: #E6E3B5;
  padding: 24px 32px;
  border-radius: 48px;
  /* height: 582px; */
  /* left: 832px; */
  /* position: absolute; */
  /* top: 241px; */
  /* width: 745px; */
}
.historique .title-container {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  padding: 24px 0px 24px 0px;

  /* left: 53px; */
  /* position: absolute; */
  /* top: 63px; */
}

.historique .ri-chat-history-fill {
  flex: 0 0 auto;
  /* position: relative; */
}

.historique .title {
  color: #000000;
  font-family: "Bw Modelica SS02";
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 36px;
  /* margin-top: -1.00px; */
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
.historique .text-container{
  display: grid;
  grid-template-columns: 50% 1fr;
  gap: 24px;
}
  .historique .left-text{
    display: flex;
    flex-direction: column;
    justify-content: space-between
}
.historique p {
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  /* left: 373px; */
  letter-spacing: 0;
  line-height: 20px;
  padding-left: 12px;
  
  /* position: absolute; */
  /* top: 362px; */
  /* width: 329px; */
}



.historique .img-wrapper {
  padding-left: 12px;
  height: max-content;
  width: max-content;
  /* background: #000; */
  display: flex;
  gap: 4px;
  align-items: start;
  justify-content: start;
  margin-bottom: 24px;
}

.historique .image-container {
  flex: 1;
  flex-grow: 1;
  object-fit: cover;
  position: relative;
  /* width: 160px;
  height: 160px; */
  width: -webkit-fill-available;
  height: -webkit-fill-available;
}

.historique .img {
  border-radius: 8px;
  flex: 1;
  flex-grow: 1;
  height: 120px;
  /* height: -webkit-fill-available; */
  position: relative;
}
@media (max-width:1200px){
  .historique {
    width: 100%;
  }
  .historique .text-container{
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

</style>